// import React from "react";

// import DashedLine from "../../../components/DashedLine/DashedLine";
// import DashedLine2 from "../../../components/DashedLine/DashedLine2";
// import SolidLine from "../../../components/DashedLine/SolidLine";
// import {
//   formatPhoneNumber,
//   formatPrice,
//   numberToWords,
//   invoiceCalculate,
// } from "../../../utils/Common";
// import Watermark from "../Watermark/Watermark";
// import "./PdfHtmlFor3mmNew.css";
// import QRCode from "react-qr-code";

// const PdfHtmlFor3mmNew = (props) => {
//   const { invoice, invoiceSetting, parentClassName } = props; // Removed id as it wasn't used

//   const BASE_URL = process.env.REACT_APP_ROOT_URL;

//   const invoiceDate = new Date(invoice?.created_at);
//   const year = invoiceDate.getFullYear();
//   const month = String(invoiceDate.getMonth() + 1).padStart(2, "0");
//   const day = String(invoiceDate.getDate()).padStart(2, "0");
//   const hours = String(invoiceDate.getHours() % 12 || 12).padStart(2, "0"); // 12-hour format, 0 becomes 12
//   const minutes = String(invoiceDate.getMinutes()).padStart(2, "0");
//   const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM";

//   const shop_logo = invoiceSetting?.shop_logo
//     ? invoiceSetting?.shop_logo
//     : `${BASE_URL}/layoutlogo.svg`;

//   const formattedDate = `${year}-${month}-${day}`;
//   const formattedTime = `${hours}:${minutes}${ampm}`;

//   let totalQty = 0;
//   let totalItems = 0;
//   let totalPrice = 0;

//   const user = JSON.parse(localStorage.getItem("user"));

//   return (
//     <div
//       style={{
//         padding: "0px",
//         fontFamily: "Arial",
//         fontSize: "12px", // Base font size reduced
//         margin: "0",
//       }}
//       id="pdfConentAreas3New"
//       className="pdfConentAreas3New p-0"
//     >
//       <div
//         style={{
//           padding: "0px",
//           maxWidth: "350px", // Retained max-width for receipt format
//           margin: "0 auto",
//           fontFamily: "Arial",
//           fontSize: "12px",
//         }}
//         id="pdfConentAreas3New"
//         className="pdfConentAreas3New p-0"
//       >
//         <div id="invoice-detail-page" className="invoice-detail-page">
//           <div className="invoice-header">
//             {/* START: Left-aligned logo and right-aligned info for compactness */}
//             <div className="flex justify-between items-center w-full">
//               <div className="invoice-logo invoice-logo-pdf flex justify-start">
//                 {invoice?.user_info && (
//                   <h1 className="text-black uppercase font-bold text-sm"> {/* Reduced text-lg to text-sm */}
//                     {invoice?.user_info?.outlet_name || invoice?.user_info?.owner_name}
//                   </h1>
//                 )}
//               </div>

//               <div
//                 className="flex flex-col text-right"
//                 style={{ fontSize: "10px", minWidth: "150px" }} // Reduced font size here
//               >

//                 {invoice?.user_info?.address && (
//                   <p className=" text-black relative">
//                      Address:{" "}
//                     {invoice?.user_info?.address}
//                   </p>
//                 )}
//                 {/* {invoice?.user_info?.email && (
//                   <p className=" text-black relative">
//                      Email:{" "}
//                     {invoice?.user_info?.email}
//                   </p>
//                 )} */}
//                 {invoice?.user_info?.phone && (
//                   <p className="text-black">
//                     Mobile:{" "}
//                     {formatPhoneNumber(
//                       invoice?.user_info?.phone,
//                       invoice?.user_info?.country_code
//                     )}
//                   </p>
//                 )}
//               </div>
//             </div>
//             {/* END: Left-aligned logo and right-aligned info */}

//             {/* Receipt Title and Invoice ID */}
//             <div className="flex justify-center items-center w-full">
//               <div
//                 style={{ fontSize: "11px" }} // Reduced font size
//                 className="w-full text-center my-1" // Reduced vertical margin
//               >
//                 {/* Token Number */}
//                 <div
//                   className="token-number"
//                   style={{ color: invoiceSetting?.first_code || "#000" }}
//                 >
//                   {invoice?.table?.table_name}
//                 </div>

//                 <SolidLine />
//               </div>
//             </div>
//           </div>

//           {/* Customer & Attended By Info */}
//           <div className="flex justify-between ">
//             <div
//             style={{ fontSize: "11px" }} // Reduced font size
//             className="invoice-customer flex flex-col items-start font-medium"
//           >
//             <div>
//               <p>Date: {formattedDate}</p>
//             </div>
//             <div>
//               <p>Time: {formattedTime}</p>
//             </div>
//             <div>
//               <p>
//                 Attended By: {invoice?.saler?.name}
//               </p>
//             </div>
//             <SolidLine />
//           </div>
//           <div className="flex flex-col items-end mt-0 pt-0" style={{ fontSize: "10px" }}> {/* Reduced font size */}
//             <div className="">
//                   <h2 className="text-base text-black font-bold"> {/* Reduced text-lg to text-base */}
//                     Sales Receipt
//                   </h2>
//                 </div>
//                 <div className="mt-1">
//                   <p className="text-xs font-bold text-black"> {/* Reduced text-sm to text-xs */}
//                     {invoice?.invoice_id}
//                   </p>
//                 </div>
//           </div>
//           </div>

//           {/* Invoice Items Table */}
//           <div className="invoice-items mt-1">
//             <table className="table">
//               <thead className="border-1 border-black">
//                 <tr className="border-none">
//                   <th className="!text-[10px] font-bold">Name</th> {/* Reduced font size */}
//                   <th className=" !text-[10px] font-bold">Price</th> {/* Reduced font size */}
//                   <th className=" !text-[10px] font-bold">Qty</th> {/* Reduced font size */}
//                   <th className="!text-[10px] text-right font-bold"> {/* Reduced font size */}
//                     Total
//                   </th>
//                 </tr>
//               </thead>

//               <tbody className="p-0">
//                 <Watermark
//                   watermark_text={invoiceSetting?.watermark_text}
//                   watermark_type={invoiceSetting?.watermark_type}
//                 ></Watermark>

//                 {invoice?.sales_details.map((item) => {
//                   totalQty += Number(item.qty);
//                   totalItems += 1;
//                   const subtotalPrice = formatPrice(item.qty * item.price);
//                   totalPrice += Number(subtotalPrice);

//                   return (
//                     <tr key={item.id}>
//                       <td
//                         className="border-b border-gray-300 pr-2 text-xs font-medium break-words whitespace-normal"
//                         style={{
//                           paddingLeft: "0",
//                           fontSize: "10px", // Reduced font size
//                           fontWeight: "500",
//                         }}
//                       >
//                         {item?.product_info?.name}
//                       </td>

//                       <td
//                         className="border-b border-gray-300"
//                         style={{
//                           fontSize: "10px", // Reduced font size
//                           whiteSpace: "nowrap",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {item.price}
//                       </td>

//                       <td
//                         className="border-b border-gray-300"
//                         style={{
//                           fontSize: "10px", // Reduced font size
//                           whiteSpace: "nowrap",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {item.qty}
//                       </td>

//                       <td
//                         className="border-b border-gray-300"
//                         style={{
//                           paddingRight: "0",
//                           fontSize: "10px", // Reduced font size
//                           textAlign: "right",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {subtotalPrice}
//                         {invoiceSetting?.currency_info?.code
//                           ? invoiceSetting?.currency_info?.code
//                           : ""}
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//             <SolidLine />
//           </div>

//           {/* Invoice Summary */}
//           <div className="invoice-summary font-extrabold">
//             <p
//               style={{ fontSize: "10px" }} // Reduced font size
//               className="flex text-black font-extrabold justify-between border-b border-black mt-1 py-1" // Reduced padding/margin
//             >
//               <span className="">TOTAL ITEMS</span>
//               <span className="">{totalItems}</span>
//             </p>

//             <p
//               style={{ fontSize: "10px" }} // Reduced font size
//               className="flex text-black font-extrabold justify-between border-b border-black py-1"
//             >
//               <span className="">SUB TOTAL</span>
//               <span className="">
//                 {formatPrice(totalPrice)}
//                 {invoiceSetting?.currency_info?.code
//                   ? invoiceSetting?.currency_info?.code
//                   : " BDT"}
//               </span>
//             </p>

//             <p
//               style={{ fontSize: "10px" }} // Reduced font size
//               className="flex text-black font-extrabold justify-between border-b border-black py-1"
//             >
//               <span className="">DISCOUNT</span>
//               <span className="">
//                 {formatPrice(invoice?.discount ? invoice?.discount : 0)}
//                 {invoiceSetting?.currency_info?.code
//                   ? invoiceSetting?.currency_info?.code
//                   : " BDT"}
//               </span>
//             </p>

//             {(parseInt(user.type) !== 4 || invoice?.status === 1) && (
//               <>
//                 <p
//                   style={{ fontSize: "10px" }} // Reduced font size
//                   className="flex text-black font-extrabold justify-between border-b border-black py-1"
//                 >
//                   <span className="">Vat</span>
//                   <span className="">
//                     {invoice?.vat ? formatPrice(invoice?.vat) : 0.0}
//                     {invoiceSetting?.currency_info?.code
//                       ? invoiceSetting?.currency_info?.code
//                       : " BDT"}
//                   </span>
//                 </p>

//                 <p
//                   style={{ fontSize: "10px" }} // Reduced font size
//                   className="flex text-black font-extrabold justify-between border-b border-black py-1"
//                 >
//                   <span className="">Service Charge</span>
//                   <span className="">
//                     {invoice?.tax ? formatPrice(invoice?.tax) : 0.0}
//                     {invoiceSetting?.currency_info?.code
//                       ? invoiceSetting?.currency_info?.code
//                       : " BDT"}
//                   </span>
//                 </p>
//               </>
//             )}

//             <p
//               style={{ fontSize: "11px" }} // Slightly larger font for grand total
//               className="flex text-black font-extrabold justify-between py-1 border-t border-b border-black" // Added top/bottom border
//             >
//               <span className="">** GRAND TOTAL **</span>
//               <span className="">
//                 {formatPrice(invoiceCalculate(invoice).grandTotal)}
//                 {invoiceSetting?.currency_info?.code
//                   ? invoiceSetting?.currency_info?.code
//                   : " BDT"}
//               </span>
//             </p>
//           </div>
//           <SolidLine />

//           {/* Payment and Due details */}
//           {(parseInt(user.type) !== 4 || invoice?.status === 1) && (
//             <>
//               <p
//                 style={{ fontSize: "10px" }} // Reduced font size
//                 className="flex text-black font-extrabold justify-between mt-1"
//               >
//                 <span className="">Paid Amount</span>
//                 <span className="">
//                   {invoice.paid_amount && invoice.paid_amount !== ""
//                     ? formatPrice(invoice.paid_amount)
//                     : formatPrice(0)}
//                   {invoiceSetting?.currency_info?.code
//                     ? invoiceSetting?.currency_info?.code
//                     : " BDT"}
//                 </span>
//               </p>

//               <p
//                 style={{ fontSize: "10px" }} // Reduced font size
//                 className="flex text-black font-extrabold justify-between"
//               >
//                 <span className="">Change</span>
//                 <span className="">
//                   {invoice?.cash_change && invoice?.cash_change !== ""
//                     ? formatPrice(parseFloat(invoice?.cash_change))
//                     : formatPrice(0)}
//                   {invoiceSetting?.currency_info?.code
//                     ? invoiceSetting?.currency_info?.code
//                     : " BDT"}
//                 </span>
//               </p>

//               {invoice.multiple_payment?.length > 0 && (
//                 <div
//                   style={{ fontSize: "10px" }} // Reduced font size
//                   className="text-black font-extrabold py-1"
//                 >
//                   {invoice.multiple_payment.map((payment, index) => (
//                     <p
//                       key={index}
//                       style={{ fontSize: "10px" }}
//                       className="flex text-black font-extrabold justify-between"
//                     >
//                       <span>{payment.payment_type?.type_name || "N/A"}</span>
//                       <span>
//                         {payment.payment_amount
//                           ? `${formatPrice(payment.payment_amount)}${
//                               invoiceSetting?.currency_info?.code || " BDT"
//                             }`
//                           : "0 BDT"}
//                       </span>
//                     </p>
//                   ))}
//                 </div>
//               )}

//               <p
//                 style={{ fontSize: "10px" }} // Reduced font size
//                 className="flex text-black font-extrabold justify-between"
//               >
//                 <span className="">Due Amount</span>
//                 <span className="">
//                   {formatPrice(invoiceCalculate(invoice).dueAmount)}
//                   {invoiceSetting?.currency_info?.code
//                     ? invoiceSetting?.currency_info?.code
//                     : " BDT"}
//                 </span>
//               </p>
//             </>
//           )}

//           <hr className="mt-1 mb-1"></hr> {/* Used simple hr instead of SolidLine for separation */}

//           {/* Footer Messages & QR Code */}
//           <div
//             className=""
//             style={{
//               textAlign: "center",
//               marginLeft: "auto",
//               marginRight: "auto",
//               fontSize: "10px", // Reduced font size
//             }}
//           >
//             <p className="font-bold p-1 text-black"> {/* Reduced padding */}
//               In word:{" "}
//               {numberToWords(formatPrice(invoiceCalculate(invoice).grandTotal))}{" "}
//               taka only
//             </p>

//             <p className="p-1 uppercase text-black"> {/* Reduced padding */}
//               You saved {formatPrice(invoice?.discount ? invoice?.discount : 0)}
//               {invoiceSetting?.currency_info?.code
//                 ? invoiceSetting?.currency_info?.code
//                 : " BDT"}{" "}
//               in this purchase
//             </p>

//             <p className="pl-1 pr-1 uppercase text-black font-bold"> {/* Reduced padding and added bold */}
//               Thanks for purchase
//             </p>

//             {/* START: Inserted Bengali Terms and Conditions Here */}
//             {invoice?.user_info?.type == 2 && (
//               <div className="mt-1 mb-1 p-1 border-t border-b border-dashed border-gray-500"> {/* Added dashed border for visibility */}
//                  <h1 className="font-nunito font-thin text-xs text-left">
//                   {" "}
//                   ১. বিল প্রদর্শন সাপেক্ষে ৭ দিনের মধ্যে ঔষধ পরিবর্তনযোগ্য। নগদ
//                   টাকা প্রদান করা হয়না।
//                 </h1>
//                 <h1 className="font-nunito font-thin text-xs text-left">
//                   {" "}
//                   ২. কাটা পাতা ও ফ্রিজিং ঔষধ, ইনসুলিন এবং যাবতীয় নন-ফার্মা পণ্য
//                   অফেরতযোগ্য।
//                 </h1>
//               </div>
//             )}
//             {/* END: Bengali Terms and Conditions */}

//             <div className="mt-2 mb-2"> {/* Adjusted margin */}
//               <QRCode
//                 className="mx-auto w-[60px] object-contain"
//                 value={BASE_URL + "/invoice/" + invoice?.invoice_id}
//                 size={50} // Reduced QR size
//               />
//             </div>

//             <p className="text-[8px] pl-1 pr-1 uppercase mt-1 font-bold text-black"> {/* Reduced font size to 8px */}
//               A Product of SQUAD INNOVATORS
//             </p>

//             <a
//               href="https://www.outletexpense.com"
//               className="text-[8px] pl-1 pr-1 mt-1 font-bold text-black"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               www.outletexpense.com
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PdfHtmlFor3mmNew;

// _______________________________________

// import React from "react";

// import DashedLine from "../../../components/DashedLine/DashedLine";
// import DashedLine2 from "../../../components/DashedLine/DashedLine2";
// import SolidLine from "../../../components/DashedLine/SolidLine";
// import {
//   formatPhoneNumber,
//   formatPrice,
//   numberToWords,
//   invoiceCalculate,
// } from "../../../utils/Common";
// import Watermark from "../Watermark/Watermark";
// import "./PdfHtmlFor3mmNew.css";
// import QRCode from "react-qr-code";

// const PdfHtmlFor3mmNew = (props) => {
//   const { invoice, invoiceSetting, parentClassName } = props; // Removed id as it wasn't used

//   const BASE_URL = process.env.REACT_APP_ROOT_URL;

//   const invoiceDate = new Date(invoice?.created_at);
//   const year = invoiceDate.getFullYear();
//   const month = String(invoiceDate.getMonth() + 1).padStart(2, "0");
//   const day = String(invoiceDate.getDate()).padStart(2, "0");
//   const hours = String(invoiceDate.getHours() % 12 || 12).padStart(2, "0"); // 12-hour format, 0 becomes 12
//   const minutes = String(invoiceDate.getMinutes()).padStart(2, "0");
//   const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM";

//   const shop_logo = invoiceSetting?.shop_logo
//     ? invoiceSetting?.shop_logo
//     : `${BASE_URL}/layoutlogo.svg`;

//   const formattedDate = `${year}-${month}-${day}`;
//   const formattedTime = `${hours}:${minutes}${ampm}`;

//   let totalQty = 0;
//   let totalItems = 0;
//   let totalPrice = 0;

//   const user = JSON.parse(localStorage.getItem("user"));

//   return (
//     <div
//       style={{
//         padding: "0px",
//         fontFamily: "Arial",
//         fontSize: "13px", // Slightly increased for visibility
//         margin: "0",
//       }}
//       id="pdfConentAreas3New"
//       className="pdfConentAreas3New p-0"
//     >
//       <div
//         style={{
//           padding: "0px",
//           maxWidth: "350px",
//           margin: "0 auto",
//           fontFamily: "Arial",
//           fontSize: "13px", // Slightly increased for readability
//         }}
//         id="pdfConentAreas3New"
//         className="pdfConentAreas3New p-0"
//       >
//         <div id="invoice-detail-page" className="invoice-detail-page">
//           <div className="invoice-header">
//             {/* START: Left-aligned logo and right-aligned info */}
//             <div className="flex justify-between items-start w-full">
//               {/* Left Side: Outlet Name, Address, Mobile */}
//               <div className="invoice-logo invoice-logo-pdf flex flex-col justify-start text-left">
//                 {invoice?.user_info && (
//                   <>
//                     <h1 className="text-black uppercase font-bold text-base">
//                       {invoice?.user_info?.outlet_name ||
//                         invoice?.user_info?.owner_name}
//                     </h1>

//                     {invoice?.user_info?.address && (
//                       <p className="text-black relative text-[11px] mt-1">
//                         Address: {invoice?.user_info?.address}
//                       </p>
//                     )}
//                     {invoice?.user_info?.phone && (
//                       <p className="text-black text-[11px]">
//                         Mobile:{" "}
//                         {formatPhoneNumber(
//                           invoice?.user_info?.phone,
//                           invoice?.user_info?.country_code
//                         )}
//                       </p>
//                     )}
//                   </>
//                 )}
//               </div>

//               {/* Right Side: Sales Receipt and Invoice No */}
//               <div
//                 className="flex flex-col text-right"
//                 style={{ fontSize: "12px", minWidth: "150px" }}
//               >
//                 <div>
//                   <h2 className="text-base text-black font-bold">
//                     Sales Receipt
//                   </h2>
//                 </div>
//                 <div className="mt-1">
//                   <p className="text-sm font-bold text-black">
//                     {invoice?.invoice_id}
//                   </p>
//                 </div>
//               </div>
//             </div>
//             {/* END: Left-aligned logo and right-aligned info */}

//             {/* Token Number Section */}
//             <div className="flex justify-center items-center w-full">
//               <div
//                 style={{ fontSize: "12px" }}
//                 className="w-full text-center my-1"
//               >
//                 <div
//                   className="token-number"
//                   style={{ color: invoiceSetting?.first_code || "#000" }}
//                 >
//                   {invoice?.table?.table_name}
//                 </div>
//                 <SolidLine />
//               </div>
//             </div>
//           </div>

//           {/* Customer & Attended By Info */}
//           <div className="flex justify-between">
//             {/* Left Side: Date & Time */}
//             <div
//               style={{ fontSize: "12px" }} // Unified readable font size
//               className="invoice-customer flex flex-col items-start font-medium leading-tight"
//             >
//               <p>Date: {formattedDate}</p>
//               <p>Time: {formattedTime}</p>
//             </div>

//             {/* Right Side: Attended By & Customer - matching style */}
//             <div
//               style={{ fontSize: "12px", textAlign: "right" }} // Same size, right aligned
//               className="invoice-customer flex flex-col items-end font-medium leading-tight"
//             >
//               <p>Attended By: {invoice?.saler?.name}</p>
//               {invoice?.customer_name && (
//                 <p>Customer: {invoice?.customer_name}</p>
//               )}
//             </div>
//           </div>
//           <div className="my-2">
//             <SolidLine />
//           </div>
//           {/* Invoice Items Table */}
//           <div className="invoice-items">
//             <table className="table">
//               <thead className="border-1 border-black">
//                 <tr className="border-none">
//                   <th className="!text-[11px] font-bold">Name</th>
//                   <th className="!text-[11px] font-bold">Price</th>
//                   <th className="!text-[11px] font-bold">Qty</th>
//                   <th className="!text-[11px] text-right font-bold">Total</th>
//                 </tr>
//               </thead>

//               <tbody className="p-0">
//                 <Watermark
//                   watermark_text={invoiceSetting?.watermark_text}
//                   watermark_type={invoiceSetting?.watermark_type}
//                 ></Watermark>

//                 {invoice?.sales_details.map((item) => {
//                   totalQty += Number(item.qty);
//                   totalItems += 1;
//                   const subtotalPrice = formatPrice(item.qty * item.price);
//                   totalPrice += Number(subtotalPrice);

//                   return (
//                     <tr key={item.id}>
//                       <td
//                         className="border-b border-gray-300 pr-2 text-xs font-medium break-words whitespace-normal"
//                         style={{
//                           paddingLeft: "0",
//                           fontSize: "11px",
//                           fontWeight: "500",
//                         }}
//                       >
//                         {item?.product_info?.name}
//                       </td>

//                       <td
//                         className="border-b border-gray-300"
//                         style={{
//                           fontSize: "11px",
//                           whiteSpace: "nowrap",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {item.price}
//                       </td>

//                       <td
//                         className="border-b border-gray-300"
//                         style={{
//                           fontSize: "11px",
//                           whiteSpace: "nowrap",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {item.qty}
//                       </td>

//                       <td
//                         className="border-b border-gray-300"
//                         style={{
//                           paddingRight: "0",
//                           fontSize: "11px",
//                           textAlign: "right",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {subtotalPrice}
//                         {invoiceSetting?.currency_info?.code
//                           ? invoiceSetting?.currency_info?.code
//                           : ""}
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//             <SolidLine />
//           </div>

//           {/* Invoice Summary */}
//           <div className="invoice-summary font-extrabold">
//             <p
//               style={{ fontSize: "11px" }}
//               className="flex text-black font-extrabold justify-between border-b border-black mt-1 py-1"
//             >
//               <span className="">TOTAL ITEMS</span>
//               <span className="">{totalItems}</span>
//             </p>

//             <p
//               style={{ fontSize: "11px" }}
//               className="flex text-black font-extrabold justify-between border-b border-black py-1"
//             >
//               <span className="">SUB TOTAL</span>
//               <span className="">
//                 {formatPrice(totalPrice)}
//                 {invoiceSetting?.currency_info?.code
//                   ? invoiceSetting?.currency_info?.code
//                   : " BDT"}
//               </span>
//             </p>

//             <p
//               style={{ fontSize: "11px" }}
//               className="flex text-black font-extrabold justify-between border-b border-black py-1"
//             >
//               <span className="">DISCOUNT</span>
//               <span className="">
//                 {formatPrice(invoice?.discount ? invoice?.discount : 0)}
//                 {invoiceSetting?.currency_info?.code
//                   ? invoiceSetting?.currency_info?.code
//                   : " BDT"}
//               </span>
//             </p>

//             {(parseInt(user.type) !== 4 || invoice?.status === 1) && (
//               <>
//                 <p
//                   style={{ fontSize: "11px" }}
//                   className="flex text-black font-extrabold justify-between border-b border-black py-1"
//                 >
//                   <span className="">Vat</span>
//                   <span className="">
//                     {invoice?.vat ? formatPrice(invoice?.vat) : 0.0}
//                     {invoiceSetting?.currency_info?.code
//                       ? invoiceSetting?.currency_info?.code
//                       : " BDT"}
//                   </span>
//                 </p>

//                 <p
//                   style={{ fontSize: "11px" }}
//                   className="flex text-black font-extrabold justify-between border-b border-black py-1"
//                 >
//                   <span className="">Service Charge</span>
//                   <span className="">
//                     {invoice?.tax ? formatPrice(invoice?.tax) : 0.0}
//                     {invoiceSetting?.currency_info?.code
//                       ? invoiceSetting?.currency_info?.code
//                       : " BDT"}
//                   </span>
//                 </p>
//               </>
//             )}

//             <p
//               style={{ fontSize: "12px" }}
//               className="flex text-black font-extrabold justify-between py-1 border-t border-b border-black"
//             >
//               <span className="">** GRAND TOTAL **</span>
//               <span className="">
//                 {formatPrice(invoiceCalculate(invoice).grandTotal)}
//                 {invoiceSetting?.currency_info?.code
//                   ? invoiceSetting?.currency_info?.code
//                   : " BDT"}
//               </span>
//             </p>
//           </div>
//           <SolidLine />

//           {/* Payment and Due details */}
//           {(parseInt(user.type) !== 4 || invoice?.status === 1) && (
//             <>
//               <p
//                 style={{ fontSize: "11px" }}
//                 className="flex text-black font-extrabold justify-between mt-1"
//               >
//                 <span className="">Paid Amount</span>
//                 <span className="">
//                   {invoice.paid_amount && invoice.paid_amount !== ""
//                     ? formatPrice(invoice.paid_amount)
//                     : formatPrice(0)}
//                   {invoiceSetting?.currency_info?.code
//                     ? invoiceSetting?.currency_info?.code
//                     : " BDT"}
//                 </span>
//               </p>

//               <p
//                 style={{ fontSize: "11px" }}
//                 className="flex text-black font-extrabold justify-between"
//               >
//                 <span className="">Change</span>
//                 <span className="">
//                   {invoice?.cash_change && invoice?.cash_change !== ""
//                     ? formatPrice(parseFloat(invoice?.cash_change))
//                     : formatPrice(0)}
//                   {invoiceSetting?.currency_info?.code
//                     ? invoiceSetting?.currency_info?.code
//                     : " BDT"}
//                 </span>
//               </p>

//               {invoice.multiple_payment?.length > 0 && (
//                 <div
//                   style={{ fontSize: "11px" }}
//                   className="text-black font-extrabold py-1"
//                 >
//                   {invoice.multiple_payment.map((payment, index) => (
//                     <p
//                       key={index}
//                       style={{ fontSize: "11px" }}
//                       className="flex text-black font-extrabold justify-between"
//                     >
//                       <span>{payment.payment_type?.type_name || "N/A"}</span>
//                       <span>
//                         {payment.payment_amount
//                           ? `${formatPrice(payment.payment_amount)}${
//                               invoiceSetting?.currency_info?.code || " BDT"
//                             }`
//                           : "0 BDT"}
//                       </span>
//                     </p>
//                   ))}
//                 </div>
//               )}

//               <p
//                 style={{ fontSize: "11px" }}
//                 className="flex text-black font-extrabold justify-between"
//               >
//                 <span className="">Due Amount</span>
//                 <span className="">
//                   {formatPrice(invoiceCalculate(invoice).dueAmount)}
//                   {invoiceSetting?.currency_info?.code
//                     ? invoiceSetting?.currency_info?.code
//                     : " BDT"}
//                 </span>
//               </p>
//             </>
//           )}

//           <hr className="mt-1 mb-1"></hr>

//           {/* Footer Messages & QR Code */}
//           <div
//             className=""
//             style={{
//               textAlign: "center",
//               marginLeft: "auto",
//               marginRight: "auto",
//               fontSize: "11px",
//             }}
//           >
//             <p className="font-bold p-1 text-black">
//               In word:{" "}
//               {numberToWords(formatPrice(invoiceCalculate(invoice).grandTotal))}{" "}
//               taka only
//             </p>

//             <p className="p-1 uppercase text-black">
//               You saved {formatPrice(invoice?.discount ? invoice?.discount : 0)}
//               {invoiceSetting?.currency_info?.code
//                 ? invoiceSetting?.currency_info?.code
//                 : " BDT"}{" "}
//               in this purchase
//             </p>

//             <p className="pl-1 pr-1 uppercase text-black font-bold">
//               Thanks for purchase
//             </p>

//             {invoice?.user_info?.type == 2 && (
//               <div className="mt-1 mb-1 p-1 border-t border-b border-dashed border-gray-500">
//                 <h1 className="font-nunito font-thin text-xs text-left">
//                   ১. বিল প্রদর্শন সাপেক্ষে ৭ দিনের মধ্যে ঔষধ পরিবর্তনযোগ্য। নগদ
//                   টাকা প্রদান করা হয়না।
//                 </h1>
//                 <h1 className="font-nunito font-thin text-xs text-left">
//                   ২. কাটা পাতা ও ফ্রিজিং ঔষধ, ইনসুলিন এবং যাবতীয় নন-ফার্মা পণ্য
//                   অফেরতযোগ্য।
//                 </h1>
//               </div>
//             )}

//             <div className="mt-2 mb-2">
//               <QRCode
//                 className="mx-auto w-[60px] object-contain"
//                 value={BASE_URL + "/invoice/" + invoice?.invoice_id}
//                 size={55}
//               />
//             </div>

//             <p className="text-[9px] pl-1 pr-1 uppercase mt-1 font-bold text-black">
//               A Product of SQUAD INNOVATORS
//             </p>

//             <a
//               href="https://www.outletexpense.com"
//               className="text-[9px] pl-1 pr-1 mt-1 font-bold text-black"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               www.outletexpense.com
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PdfHtmlFor3mmNew;

// ________________________________________


import React from "react";

import DashedLine from "../../../components/DashedLine/DashedLine";
import DashedLine2 from "../../../components/DashedLine/DashedLine2";
import SolidLine from "../../../components/DashedLine/SolidLine";
import {
  formatPhoneNumber,
  formatPrice,
  numberToWords,
  invoiceCalculate,
} from "../../../utils/Common";
import Watermark from "../Watermark/Watermark";
import "./PdfHtmlFor3mmNew.css";
import QRCode from "react-qr-code";

const PdfHtmlFor3mmNew = (props) => {
  const { invoice, invoiceSetting, parentClassName } = props; // Removed id as it wasn't used

  const BASE_URL = process.env.REACT_APP_ROOT_URL;

  const invoiceDate = new Date(invoice?.created_at);
  const year = invoiceDate.getFullYear();
  const month = String(invoiceDate.getMonth() + 1).padStart(2, "0");
  const day = String(invoiceDate.getDate()).padStart(2, "0");
  const hours = String(invoiceDate.getHours() % 12 || 12).padStart(2, "0"); // 12-hour format, 0 becomes 12
  const minutes = String(invoiceDate.getMinutes()).padStart(2, "0");
  const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM";

  const shop_logo = invoiceSetting?.shop_logo
    ? invoiceSetting?.shop_logo
    : `${BASE_URL}/layoutlogo.svg`;

  const formattedDate = `${year}-${month}-${day}`;
  const formattedTime = `${hours}:${minutes}${ampm}`;

  let totalQty = 0;
  let totalItems = 0;
  let totalPrice = 0;

  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div
      style={{
        padding: "1px",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "14px", // Increased from 13px for better visibility
        color: "#000000",
        margin: "0",
      }}
      id="pdfConentAreas3New"
      className="pdfConentAreas3New p-0"
    >
      <div
        style={{
          padding: "0px",
          maxWidth: "350px",
          margin: "0 auto",
          fontFamily: "Arial, Helvetica, sans-serif",
          fontSize: "14px", // Increased for readability
          color: "#000000",
        }}
        id="pdfConentAreas3New"
        className="pdfConentAreas3New p-0"
      >
        <div id="invoice-detail-page" className="invoice-detail-page">
          <div className="invoice-header">
            {/* START: Left-aligned logo and right-aligned info */}
            <div className="flex justify-between items-start w-full">
              {/* Left Side: Outlet Name, Address, Mobile */}
              <div className="invoice-logo invoice-logo-pdf flex flex-col justify-start text-left">
                {invoice?.user_info && (
                  <>
                    <h1 className="text-black uppercase font-bold text-lg">
                      {invoice?.user_info?.outlet_name ||
                        invoice?.user_info?.owner_name}
                    </h1>

                    {invoice?.user_info?.address && (
                      <p className="text-black relative text-[12px] mt-1 font-semibold">
                        Address: {invoice?.user_info?.address}
                      </p>
                    )}
                    {invoice?.user_info?.phone && (
                      <p className="text-black text-[12px] font-semibold">
                        Mobile:{" "}
                        {formatPhoneNumber(
                          invoice?.user_info?.phone,
                          invoice?.user_info?.country_code
                        )}
                      </p>
                    )}
                  </>
                )}
              </div>

              {/* Right Side: Sales Receipt and Invoice No */}
              <div
                className="flex flex-col text-right"
                style={{ fontSize: "13px", minWidth: "150px", color: "#000" }}
              >
                <div>
                  <h2 className="text-lg text-black font-bold">Sales Receipt</h2>
                </div>
                <div className="mt-1">
                  <p className="text-md font-bold text-black">
                    {invoice?.invoice_id}
                  </p>
                </div>
              </div>
            </div>
            {/* END: Left-aligned logo and right-aligned info */}

            {/* Token Number Section */}
            <div className="flex justify-center items-center w-full">
              <div
                style={{ fontSize: "13px" }}
                className="w-full text-center my-1"
              >
                <div
                  className="token-number font-bold"
                  style={{ color: invoiceSetting?.first_code || "#000" }}
                >
                  {invoice?.table?.table_name}
                </div>
                <SolidLine />
              </div>
            </div>
          </div>

          {/* Customer & Attended By Info */}
          <div className="flex justify-between">
            {/* Left Side: Date & Time */}
            <div
              style={{ fontSize: "13px" }}
              className="invoice-customer flex flex-col items-start font-semibold leading-tight"
            >
              <p>Date: {formattedDate}</p>
              <p>Time: {formattedTime}</p>
            </div>

            {/* Right Side: Attended By & Customer */}
            <div
              style={{ fontSize: "13px", textAlign: "right" }}
              className="invoice-customer flex flex-col items-end font-semibold leading-tight"
            >
              <p>Attended By: {invoice?.saler?.name}</p>
              {invoice?.customer_name && (
                <p>Customer: {invoice?.customer_name}</p>
              )}
            </div>
          </div>
          <div className="my-2">
            <SolidLine />
          </div>

          {/* Invoice Items Table */}
          <div className="invoice-items">
            <table className="table" style={{ width: "100%" }}>
              <thead className="border-1 border-black">
                <tr className="border-none text-black">
                  <th className="!text-[12px] font-bold">Name</th>
                  <th className="!text-[12px] font-bold">Price</th>
                  <th className="!text-[12px] font-bold">Qty</th>
                  <th className="!text-[12px] text-right font-bold">Total</th>
                </tr>
              </thead>

              <tbody className="p-0 text-black">
                <Watermark
                  watermark_text={invoiceSetting?.watermark_text}
                  watermark_type={invoiceSetting?.watermark_type}
                ></Watermark>

                {invoice?.sales_details.map((item) => {
                  totalQty += Number(item.qty);
                  totalItems += 1;
                  const subtotalPrice = formatPrice(item.qty * item.price);
                  totalPrice += Number(subtotalPrice);

                  return (
                    <tr key={item.id}>
                      <td
                        className="border-b border-gray-300 pr-2 text-[12px] font-semibold break-words whitespace-normal"
                        style={{
                          paddingLeft: "0",
                          color: "#000",
                        }}
                      >
                        {item?.product_info?.name}
                      </td>

                      <td
                        className="border-b border-gray-300 text-[12px] font-bold"
                        style={{
                          color: "#000",
                        }}
                      >
                        {item.price}
                      </td>

                      <td
                        className="border-b border-gray-300 text-[12px] font-bold"
                        style={{
                          color: "#000",
                        }}
                      >
                        {item.qty}
                      </td>

                      <td
                        className="border-b border-gray-300 text-[12px] text-right font-bold"
                        style={{
                          paddingRight: "0",
                          color: "#000",
                        }}
                      >
                        {subtotalPrice}
                        {invoiceSetting?.currency_info?.code
                          ? invoiceSetting?.currency_info?.code
                          : ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <SolidLine />
          </div>

          {/* Invoice Summary */}
          <div className="invoice-summary font-extrabold text-black">
            <p
              style={{ fontSize: "12px" }}
              className="flex justify-between border-b border-black mt-1 py-1 font-bold"
            >
              <span className="">TOTAL ITEMS</span>
              <span className="">{totalItems}</span>
            </p>

            <p
              style={{ fontSize: "12px" }}
              className="flex justify-between border-b border-black py-1 font-bold"
            >
              <span className="">SUB TOTAL</span>
              <span className="">
                {formatPrice(totalPrice)}
                {invoiceSetting?.currency_info?.code
                  ? invoiceSetting?.currency_info?.code
                  : " BDT"}
              </span>
            </p>

            <p
              style={{ fontSize: "12px" }}
              className="flex justify-between border-b border-black py-1 font-bold"
            >
              <span className="">DISCOUNT</span>
              <span className="">
                {formatPrice(invoice?.discount ? invoice?.discount : 0)}
                {invoiceSetting?.currency_info?.code
                  ? invoiceSetting?.currency_info?.code
                  : " BDT"}
              </span>
            </p>

            {(parseInt(user.type) !== 4 || invoice?.status === 1) && (
              <>
                <p
                  style={{ fontSize: "12px" }}
                  className="flex justify-between border-b border-black py-1 font-bold"
                >
                  <span className="">Vat</span>
                  <span className="">
                    {invoice?.vat ? formatPrice(invoice?.vat) : 0.0}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : " BDT"}
                  </span>
                </p>

                <p
                  style={{ fontSize: "12px" }}
                  className="flex justify-between border-b border-black py-1 font-bold"
                >
                  <span className="">Service Charge</span>
                  <span className="">
                    {invoice?.tax ? formatPrice(invoice?.tax) : 0.0}
                    {invoiceSetting?.currency_info?.code
                      ? invoiceSetting?.currency_info?.code
                      : " BDT"}
                  </span>
                </p>
              </>
            )}

            <p
              style={{ fontSize: "13px" }}
              className="flex text-black font-extrabold justify-between py-1 border-t border-b border-black"
            >
              <span className="">** GRAND TOTAL **</span>
              <span className="">
                {formatPrice(invoiceCalculate(invoice).grandTotal)}
                {invoiceSetting?.currency_info?.code
                  ? invoiceSetting?.currency_info?.code
                  : " BDT"}
              </span>
            </p>
          </div>
          <SolidLine />

          {/* Payment and Due details */}
          {(parseInt(user.type) !== 4 || invoice?.status === 1) && (
            <>
              <p
                style={{ fontSize: "12px" }}
                className="flex justify-between mt-1 font-bold text-black"
              >
                <span className="">Paid Amount</span>
                <span className="">
                  {invoice.paid_amount && invoice.paid_amount !== ""
                    ? formatPrice(invoice.paid_amount)
                    : formatPrice(0)}
                  {invoiceSetting?.currency_info?.code
                    ? invoiceSetting?.currency_info?.code
                    : " BDT"}
                </span>
              </p>

              <p
                style={{ fontSize: "12px" }}
                className="flex justify-between font-bold text-black"
              >
                <span className="">Change</span>
                <span className="">
                  {invoice?.cash_change && invoice?.cash_change !== ""
                    ? formatPrice(parseFloat(invoice?.cash_change))
                    : formatPrice(0)}
                  {invoiceSetting?.currency_info?.code
                    ? invoiceSetting?.currency_info?.code
                    : " BDT"}
                </span>
              </p>

              {invoice.multiple_payment?.length > 0 && (
                <div
                  style={{ fontSize: "12px" }}
                  className="text-black font-bold py-1"
                >
                  {invoice.multiple_payment.map((payment, index) => (
                    <p
                      key={index}
                      style={{ fontSize: "12px" }}
                      className="flex justify-between text-black font-bold"
                    >
                      <span>{payment.payment_type?.type_name || "N/A"}</span>
                      <span>
                        {payment.payment_amount
                          ? `${formatPrice(payment.payment_amount)}${
                              invoiceSetting?.currency_info?.code || " BDT"
                            }`
                          : "0 BDT"}
                      </span>
                    </p>
                  ))}
                </div>
              )}

              <p
                style={{ fontSize: "12px" }}
                className="flex justify-between font-bold text-black"
              >
                <span className="">Due Amount</span>
                <span className="">
                  {formatPrice(invoiceCalculate(invoice).dueAmount)}
                  {invoiceSetting?.currency_info?.code
                    ? invoiceSetting?.currency_info?.code
                    : " BDT"}
                </span>
              </p>
            </>
          )}

          <hr className="mt-1 mb-1"></hr>

          {/* Footer Messages & QR Code */}
          <div
            className=""
            style={{
              textAlign: "center",
              marginLeft: "auto",
              marginRight: "auto",
              fontSize: "12px",
              color: "#000",
            }}
          >
            <p className="font-bold p-1 text-black">
              In word:{" "}
              {numberToWords(formatPrice(invoiceCalculate(invoice).grandTotal))}{" "}
              taka only
            </p>

            <p className="p-1 uppercase text-black font-semibold">
              You saved {formatPrice(invoice?.discount ? invoice?.discount : 0)}
              {invoiceSetting?.currency_info?.code
                ? invoiceSetting?.currency_info?.code
                : " BDT"}{" "}
              in this purchase
            </p>

            <p className="pl-1 pr-1 uppercase text-black font-bold">
              Thanks for purchase
            </p>

            {invoice?.user_info?.type == 2 && (
              <div className="mt-1 mb-1 p-1 border-t border-b border-dashed border-gray-500 text-black">
                <h1 className="font-nunito font-semibold text-[11px] text-left">
                  ১. বিল প্রদর্শন সাপেক্ষে ৭ দিনের মধ্যে ঔষধ পরিবর্তনযোগ্য। নগদ
                  টাকা প্রদান করা হয়না।
                </h1>
                <h1 className="font-nunito font-semibold text-[11px] text-left">
                  ২. কাটা পাতা ও ফ্রিজিং ঔষধ, ইনসুলিন এবং যাবতীয় নন-ফার্মা পণ্য
                  অফেরতযোগ্য।
                </h1>
              </div>
            )}

            <div className="mt-2 mb-2">
              <QRCode
                className="mx-auto w-[70px] object-contain"
                value={BASE_URL + "/invoice/" + invoice?.invoice_id}
                size={65}
              />
            </div>

            <p className="text-[10px] pl-1 pr-1 uppercase mt-1 font-bold text-black">
              A Product of SQUAD INNOVATORS
            </p>

            <a
              href="https://www.outletexpense.com"
              className="text-[10px] pl-1 pr-1 mt-1 font-bold text-black"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.outletexpense.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfHtmlFor3mmNew;
